import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import styles from "@website/ui/modal/modal.module.scss";
import { ModalPropertiesType } from "@website/ui/modal/modal.types";
import { TransitionV2 } from "@website/ui/transition";
import { useClientLoaded } from "@website/utils/client-loaded/useClientLoaded";
import { FC, MouseEvent, PropsWithChildren, useEffect } from "react";
import { createPortal } from "react-dom";
export const Modal: FC<PropsWithChildren<ModalPropertiesType>> = properties => {
  const $ = _c(32);
  const {
    fullWidth,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": ariaDescribedby,
    id,
    open,
    fullScreen,
    animate,
    children,
    title,
    onClose,
    showCloseButton,
    mobileHeight,
    className,
    closeIcon: t0,
    headerStyle,
    iconClassName,
    titleClassName: t1,
    usePortal,
    wrapperClassName
  } = properties;
  const closeIcon = t0 === undefined ? "close" : t0;
  const titleClassName = t1 === undefined ? "" : t1;
  const {
    clientLoaded
  } = useClientLoaded();
  const portalTarget = typeof document === "undefined" ? null : document.body;
  const stopPropagationOnModal = _temp;
  let t2;
  let t3;
  if ($[0] !== open) {
    t2 = () => {
      if (open) {
        document.body.classList.add("prevent-scroll");
        return _temp2;
      }
    };
    t3 = [open];
    $[0] = open;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[3] !== onClose || $[4] !== open) {
    t4 = () => {
      if (open) {
        const checkIfPressEsc = event_0 => {
          if (event_0.key === "Escape") {
            onClose?.();
            event_0.stopPropagation();
          }
        };
        document.addEventListener("keydown", checkIfPressEsc);
        return () => document.removeEventListener("keydown", checkIfPressEsc);
      }
    };
    t5 = [onClose, open];
    $[3] = onClose;
    $[4] = open;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  if (!open || !clientLoaded) {
    return null;
  }
  const t6 = fullScreen ? 0 : 200;
  let t7;
  if ($[7] !== animate || $[8] !== ariaDescribedby || $[9] !== ariaLabelledby || $[10] !== children || $[11] !== className || $[12] !== closeIcon || $[13] !== fullScreen || $[14] !== fullWidth || $[15] !== headerStyle || $[16] !== iconClassName || $[17] !== id || $[18] !== mobileHeight || $[19] !== onClose || $[20] !== showCloseButton || $[21] !== title || $[22] !== titleClassName || $[23] !== wrapperClassName) {
    t7 = state => <div className={`${styles.container} ${wrapperClassName || ""} ${state === "entering" || state === "entered" ? styles["container-in"] : styles["container-out"]} ${fullScreen ? "!size-full rounded-none p-0 md:box-content" : ""}`} data-testid="modal-container" onClick={onClose}><div role="dialog" data-full-width={fullWidth} aria-labelledby={ariaLabelledby} aria-describedby={ariaDescribedby} aria-modal={true} onClick={stopPropagationOnModal} id={id} className={`${styles.modal} ${className || ""} ${styles[mobileHeight || "full"]} ${animate === "bottom" ? `${styles.bottom} ${state === "entering" || state === "entered" ? styles["modal-in"] : styles["modal-out"]}` : ""} ${fullScreen ? "!size-full rounded-none p-0 md:box-content" : ""}`} tabIndex={0}>{showCloseButton || title ? <div className={`${headerStyle} ${styles.header}`}>{title ? <h6 className={`${styles.title} ${titleClassName} ${showCloseButton ? "max-w-[90%]" : ""}`}>{title}</h6> : ""}{showCloseButton ? <MaterialIcon className={`${styles.close} ${iconClassName || ""}`} name={closeIcon} onClick={onClose} /> : ""}</div> : null}{children}</div></div>;
    $[7] = animate;
    $[8] = ariaDescribedby;
    $[9] = ariaLabelledby;
    $[10] = children;
    $[11] = className;
    $[12] = closeIcon;
    $[13] = fullScreen;
    $[14] = fullWidth;
    $[15] = headerStyle;
    $[16] = iconClassName;
    $[17] = id;
    $[18] = mobileHeight;
    $[19] = onClose;
    $[20] = showCloseButton;
    $[21] = title;
    $[22] = titleClassName;
    $[23] = wrapperClassName;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== open || $[26] !== t6 || $[27] !== t7) {
    t8 = <TransitionV2 timeout={t6} in={open}>{t7}</TransitionV2>;
    $[25] = open;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  const content = t8;
  let t9;
  if ($[29] !== content || $[30] !== usePortal) {
    t9 = usePortal && portalTarget ? createPortal(content, portalTarget) : content;
    $[29] = content;
    $[30] = usePortal;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
};
function _temp(event) {
  event.stopPropagation();
}
function _temp2() {
  return document.body.classList.remove("prevent-scroll");
}